import React, { useEffect, useState } from 'react'
import * as StringFormatter from '../../../global/formatters/string-formatter.js'
import { updateCartCount } from '../../../global/_nav.js'
import {
  getItemsInCart,
  addToCart,
  removeFromCart,
} from '../../../global/cart.js'

import { renderLiteratureLink } from '../../../components/Resources/Helpers/Utilities.js'

import Table from '../../../components/Table/Table.jsx'

import { init } from '../../../global/authentication/secure-link-manager.js'

import { productTypes } from './Helpers/Helper.js'

export const FundLiteratureTable = ({ funds, isInvestor, showClassOption }) => {
  const [cart, setCart] = useState(getItemsInCart())

  useEffect(() => {
    init()
  }, [funds])

  const getAspect = (section) => {
    const isETF = productTypes?.['exchange-traded-funds']?.label
    const aspects = [
      {
        name: '#fundLiterature',
        info: {
          columns: [
            {
              name: 'fundName',
              className: 'Table-header',
              ariaLabel: 'Fund Name',
              content: <div>Fund Name</div>,
              button: {
                className: 'Table-headerNode u-padding2gu u-paddingRight4gu',
                sort: 'fundName',
                sortType: 'func',
                sortFunc: (fund) =>
                  (fund.productType === isETF ? fund.symbol : '') +
                  fund.fundName,
              },
              cell: {
                content: (fund) => (
                  <>
                    {fund.noLink || fund.cusip === 'null' ? (
                      <p>{fund.fundName}</p>
                    ) : (
                      <a
                        className="Link"
                        href={`${
                          isInvestor ? '/investor' : ''
                        }/investment-products/mutual-funds/${StringFormatter.urlSafe(
                          fund.fundName
                        )}/Class-${fund.fundClass}/details/?cusip=${
                          fund.cusip
                        }`}
                      >
                        {fund.productType === isETF ? fund.symbol + ' - ' : ''}
                        {fund.fundName}
                      </a>
                    )}
                  </>
                ),
                hideRepeated: (fund) => fund.fundName,
                isRepeatedKey: true,
              },
            },
            {
              name: 'fundClass',
              className: `Table-header ${!showClassOption && 'u-hidden'}`,
              ariaLabel: 'Class',
              content: <div>Class</div>,
              cell: {
                className: `u-textNoWrap ${!showClassOption && 'u-hidden'}`,
                content: (fund) =>
                  fund.fundClass === 'null' ? 'None' : fund.fundClass,
                hideRepeated: (fund) => fund.fundName,
              },
            },
            {
              name: 'productType',
              className: 'Table-header',
              ariaLabel: 'Fund Type',
              content: <div>Fund Type</div>,
              cell: {
                className: 'u-textNoWrap',
                content: (fund) => fund.productType,
                hideRepeated: (fund) => fund.fundName,
              },
            },
            {
              name: 'literatureType',
              className: 'Table-header',
              ariaLabel: 'Literature Type',
              content: <div>Literature Type</div>,
              button: {
                className: 'Table-headerNode u-padding2gu u-paddingRight4gu',
                sort: 'fileName',
                sortType: 'string',
              },
              cell: {
                content: (i) =>
                  renderLiteratureLink({
                    label:
                      (i?.docType === 'Investment Insights'
                        ? i?.docType + ' - '
                        : '') + i?.fileName,
                    url: i?.url,
                    secureDoc: i?.secureDoc,
                    fund: i,
                  }),
              },
            },
            {
              name: 'mailOrder',
              className: 'Table-header',
              ariaLabel: 'Mail Order',
              content: <div>Mail Order</div>,
              cell: {
                content: (fund) => {
                  if (
                    fund.byEmailOrder === 'false' ||
                    fund.byEmailOrder === false
                  ) {
                    return null
                  }

                  const cartId =
                    fund.cusip === 'null'
                      ? fund.fundName.replace(/ /g, '_') +
                        fund.fileName.replace(/ /g, '_')
                      : fund.cusip + fund.fileName.replace(/ /g, '_')
                  const cartJson = getCartJson(cartId, fund)
                  const isInCart = cart?.some((i) => i?.cartId === cartId)

                  return (
                    <div style={{ width: 100 }}>
                      <input
                        checked={isInCart}
                        id={'cartDoc' + cartId}
                        onChange={onClickAddCart}
                        value={cartJson}
                        type="checkbox"
                        className="Subscription-checkbox"
                        data-analytics="add-to-cart-checkbox"
                      ></input>
                      <label htmlFor={'cartDoc' + cartId}>
                        <p className="u-inlineBlock u-marginLeft1gu u-textNoWrap">
                          {isInCart ? 'In Cart' : 'Add to Cart'}{' '}
                        </p>
                      </label>
                    </div>
                  )
                },
              },
            },
          ],
        },
      },
    ]

    return aspects.find((a) => a.name === section).info
  }

  const getCartJson = (cartId, fund) => {
    const fundDocForSerialization = {}
    fundDocForSerialization.cartId = cartId
    fundDocForSerialization.fundName = fund.fundName
    fundDocForSerialization.productType = fund.fundGroup
    fundDocForSerialization.dDocType = fund.docType
    fundDocForSerialization.fileName = fund.fileName
    fundDocForSerialization.fileDDocType = fund.fileName
    fundDocForSerialization.fileUrl = fund.docURL
    fundDocForSerialization.quantity = 1
    fundDocForSerialization.orderable = true
    fundDocForSerialization.fundClass = fund.fundClass

    const cartJson = JSON.stringify(fundDocForSerialization)

    return cartJson
  }

  const onClickAddCart = (event) => {
    if (event.target.checked) {
      addToLocalCart(JSON.parse(event.target.value))
    } else {
      removeFromLocalCart(JSON.parse(event.target.value))
    }

    updateCartCount()
  }

  function addToLocalCart(item) {
    addToCart(item)

    const _cart = [...cart]

    _cart.push(item)

    setCart(_cart)
  }

  function removeFromLocalCart(item) {
    removeFromCart(item)

    let _cart = [...cart]

    _cart = _cart.filter((cartItem) => item.cartId !== cartItem.cartId)

    setCart(_cart)
  }

  const aspect = getAspect('#fundLiterature')

  return (
    <Table
      tableClass="Table-literature"
      columns={aspect.columns}
      rows={funds?.length === 0 ? [] : funds}
      isRepeated={true}
      emptyMessage={
        <>
          <strong>No matching results found.</strong> Not finding what you are
          looking for? Try another Fund Type or Literature Type.
        </>
      }
    />
  )
}
